import { Link } from "react-router-dom";
import { Heart, Instagram, Facebook, Youtube, Zap, ShieldCheck, Lock } from "lucide-react";
import Logo from "./Logo";
import { MAIN_SLUG } from "@/lib/api";

const COLS = [
  {
    title: "Doar",
    items: [
      ["Vaquinha do abrigo", `/vaquinha/${MAIN_SLUG}`],
      ["Gatinhos do gatil", "/vaquinha/ajude-os-gatinhos-do-gatil-petlovers"],
      ["Tratamento da Mel", "/vaquinha/tratamento-da-mel-filhote-resgatada"],
      ["Reforma do canil", "/vaquinha/reformando-o-canil-do-petlovers"],
    ],
  },
  {
    title: "Institucional",
    items: [
      ["Sobre nós", "/#como-ajudar"],
      ["Transparência", "/#seguranca"],
      ["Prestação de contas", `/vaquinha/${MAIN_SLUG}`],
      ["Seja voluntário", "/#como-ajudar"],
    ],
  },
  {
    title: "Ajuda",
    items: [
      ["Como doar", "/#seguranca"],
      ["Perguntas frequentes", "/#seguranca"],
      ["Contato", "/#seguranca"],
      ["Denunciar campanha", "/#seguranca"],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#261C14] text-[#CBBFB4]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div className="space-y-5">
          <Logo light />
          <p className="max-w-xs text-sm leading-relaxed">
            Amor, ração e uma segunda chance para quem tem patinhas. Doe via Pix — rápido, seguro e direto para o abrigo.
          </p>
          <div className="flex gap-3">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                aria-label="Rede social"
                className="grid h-10 w-10 place-items-center rounded-full bg-white/10 transition hover:bg-[#FF6D47]"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <p className="font-display text-sm font-extrabold uppercase tracking-wider text-white">{col.title}</p>
            <ul className="mt-4 space-y-2.5 text-sm font-semibold">
              {col.items.map(([label, href]) => (
                <li key={label}>
                  <Link to={href} className="transition hover:text-[#FF6D47]">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-6 text-xs font-semibold sm:px-6">
          <p>
            © 2025 Instituto PetLovers · CNPJ 43.192.126/0001-18 · Feito com{" "}
            <Heart className="inline h-3 w-3 fill-[#FF6D47] text-[#FF6D47]" /> para as patinhas
          </p>
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-1.5 rounded-full bg-[#32BCAD]/20 px-3 py-1.5 text-[#32BCAD]">
              <Zap className="h-3 w-3" /> Pix
            </span>
            <span className="flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5">
              <Lock className="h-3 w-3" /> SSL
            </span>
            <span className="flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5">
              <ShieldCheck className="h-3 w-3" /> LivePix
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
